<section class="w3l-form-36">
	<div class="form-36-mian section-gap" style="height: 200%;">
		<div class="wrapper">
			<div class="form-inner-cont">
				<h3>Log in to continue</h3>
				<form #userForm ="ngForm" action="#" method="post" class="signin-form">

					<div class="form-input">
						<span class="fa fa-envelope-o" aria-hidden="true"></span> <input type="text" name="userid"  (change)="retriveUsers()" [(ngModel)]="userID" placeholder="User ID" required  ngModel/>
					</div>
          <div class="form-input">
						<span class="fa fa-user" aria-hidden="true"></span> <input type="text" name="username" [ngStyle]="{'color':  styleFor}" [(ngModel)]="userName"  placeholder="User Name" readonly style="font-weight: bolder;"  />
					</div>
          <BR>
          <form action="search-results.html"  method="get"  align="center">
          <div class="appointment-form-field">

            <img src="assets/images/Person.jpg" *ngIf= "!wk_Pic_Not" class="img-circle" alt="User Image" width="70px" height="90px" style="align-items: center;border-style:ridge;"/>
            <img src="data:image/jpg;base64,{{myimage}}" *ngIf= "!wk_Pic_Not1"class="img-circle" alt="User Image" width="70px" height="90px" style="align-items: center;border-style:ridge;"/>

        </div>
         </form>
        <div class="form-input">

          <span class="fa fa-key" aria-hidden="true"></span>

          <input type="password" name="password"  placeholder="Password" [(ngModel)] ="passwordEntry"  (change)="CheckUser()" required />

        </div>

          <!-- <div class="form-input" style="width: 50%;" hidden="true">
						<span class="fa fa-bank" aria-hidden="true"></span> -->
            <input type="text" name="compCode"  [(ngModel)]="compCode1" (change)="retriveCompany()" placeholder="Site Code" ngModel	required hidden="true" />

          <!-- </div> -->
          <div  class="form-input" style="width: 100%;">
          <span class="fa fa-bank" aria-hidden="true"></span>
            <select id="location" class="form-input" name="location"  required="" [(ngModel)]="compCode1" [value]="compName" style="width: 255px;height: 25px;border: 0ch;">
              <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
            </select>
          </div>


					<input type="text" name="error"  disabled required  style="align-content: center; font-weight: bolder; color: white; background-color: red;height: 50%;width: 100%;" [hidden]="stylehidden" [(ngModel)]="lblError"/>

					<div class="login-remember d-grid">
              <label class="check-remaind">
                <input type="checkbox">
                <span class="checkmark"></span>
                <p class="remember">Remember me</p>
              </label>
              <a href="Home" (click)="$event.preventDefault()" *ngIf="!Get_Login">
                <button type="button" name="submit"  class="btn theme-button" (click)="CheckUser()" >Login</button>
              </a>
          </div>
          <!--LoginUser()-->
					<div class="new-signup">

						<a  (click)="ChangePassword()"  class="signuplink" style="cursor: grab;"
            >Change password?</a>
					</div>
				</form>


			</div>
		</div>
	</div>
  <div style="background-color: #7cbc44;width: 100%;height: 60px; align-content:center ;padding-left: -5%;">
    <label style="background-color: #7cbc44;width: 100%;align-content:center ;padding-left: -5%;">               </label>
  </div>
  <div style="background-color: #0156a7;width: 100%;height: 60px; align-content:center ;padding-left: -5%;">
    <label style="background-color: #0156a7;width: 100%;align-content:center ;padding-left: -5%;">               </label>
  </div>
  <label style="width: 100%;align-content:center ;padding-left: -5%;">  Published at 27-7-2026                              Copyright <i class="fa fa-copyright" aria-hidden="true"></i>  Focus information Technology Systems</label>

</section>
